import React, { useEffect, useCallback } from 'react';
import { useModal, useRequest } from '@stores';
import { useNavigate } from '@tanstack/react-router';
import StepHeader from '@components/step-header/StepHeader';
import NewApplicationModal from '@pages/Home/components/modals/NewApplication';
import genericSecondaryModal from '@forms/components/modals/genericSecondaryModal';
import { RequestType } from '@src/utils/enums';
import { resolveNprConfig } from '../../registry/configs/npr/nprConfig';
import { getAppStore } from '@src/utils/store-reference';

export const NprFormInstructionsMetadata = {
  header: RequestType.ActivityBasedNoPermitRequired,
  sectionName: 'Instructions',
};

const NprFormInstructions = ({ stepNo, formVariant, formVersion, requestType }) => {
  const navigate = useNavigate();
  const { openModal, openSecondaryModal } = useModal();
  const store = getAppStore();
  const updateSection = useRequest((state) => state.updateSection);
  const variant = formVariant ?? (requestType === RequestType.ActivityBasedNoPermitRequired ? 'abNpr' : 'npr');
  const version = formVersion ?? 1;

  useEffect(() => {
    updateSection(stepNo, { valid: true, label: NprFormInstructionsMetadata.sectionName });
  }, [updateSection, stepNo]);

  const handleJdLink = useCallback(() => {
    const onSaveFunc = () => {
      store.doResetReduxFormData();
      sessionStorage.setItem('nprButtonSession', true);
      const nprButtonSession = sessionStorage.getItem('nprButtonSession');
      navigate({ to: '/' });
      nprButtonSession && openModal(NewApplicationModal);
      sessionStorage.removeItem('nprButtonSession');
    };

    openSecondaryModal(genericSecondaryModal, {
      title: 'Are You Sure?',
      msg: (
        <>
          You are about to leave this application to start a new Jurisdictional Determination request. Your current{' '}
          <strong>{RequestType.ActivityBasedNoPermitRequired}</strong> request will remain accessible via the RRS
          dashboard.           
        </>
      ),
      cancelText: 'Cancel',
      saveText: 'Proceed',
      onSave: onSaveFunc,
    });
  }, [navigate, openModal, openSecondaryModal, store]);

  const { getInstructions } = resolveNprConfig(variant, version);
  const instructions = getInstructions({ variant, onJdLink: handleJdLink });

  return (
    <>
      <StepHeader text={instructions.headerText} />
      {instructions.paragraphs?.map((node, i) => (
        <React.Fragment key={node?.key ?? i}>{node}</React.Fragment>
      ))}
            
    </>
  );
};

NprFormInstructions.metadata = NprFormInstructionsMetadata;

export default NprFormInstructions;
